<template>
  <!-- Фото сообщения одной группой, раскладка как в деске поддержки; клик - просмотр поверх страницы.
       Плитки заданы пропорциями: на узком экране альбом ужимается целиком. -->
  <div class="photo-album" :style="{ width: `${layout.width}px`, gap: `${gap}px` }">
    <div
      v-for="(row, r) in layout.rows"
      :key="r"
      class="photo-album__row"
      :style="{ gap: `${gap}px` }"
    >
      <button
        v-for="tile in row"
        :key="attachments[tile.index].id"
        type="button"
        class="photo-album__item"
        :class="{ 'photo-album__item--contain': tile.contain }"
        :style="{ flexGrow: tile.width, aspectRatio: `${tile.width} / ${tile.height}` }"
        @click="$emit('open', tile.index)"
        @contextmenu.prevent.stop="$emit('menu', { attachment: attachments[tile.index], event: $event })"
      >
        <img class="photo-album__img" :src="attachments[tile.index].url" alt="">
        <span v-if="layout.more > 0 && tile.index === 5" class="photo-album__more">+{{ layout.more }}</span>
      </button>
    </div>
  </div>
</template>

<script>
  import { albumLayout, ALBUM_GAP } from '../feed'

  export default {
    name: 'PhotoAlbum',
    props: {
      attachments: { type: Array, required: true },
    },
    computed: {
      layout () {
        return albumLayout(this.attachments)
      },
      gap () {
        return ALBUM_GAP
      },
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

// Скруглены только внешние углы группы: радиус и обрезка у контейнера, внутренние стыки прямые.
.photo-album {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.photo-album__row {
  display: flex;
}

.photo-album__item {
  position: relative;
  flex-basis: 0;
  min-width: 0;
  padding: 0;
  overflow: hidden;
  background: @fakt-surface;
  cursor: zoom-in;
}

.photo-album__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

// Одно фото крайнего формата (скриншот строки таблицы): плитка не меньше 100, фото вписано целиком,
// поля - фоном плитки. scale-down = contain без увеличения: иконка 50×50 в плитке 100×100 остаётся 50×50.
.photo-album__item--contain .photo-album__img {
  object-fit: scale-down;
}

// Шестая плитка при большем числе: затемнение и «+N»
.photo-album__more {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: @fakt-white;
  background: @fakt-hint-dark;
}
</style>
